<template>
    <div class="rate">
        <div class="star" v-for="item in 5" :key="item" :style="{margin:margin}">
            <span>
                <i class="iconfont icon-pingfen" :style="{color:borderColor,fontSize:size+'px'}"></i>
                <i class="iconfont icon-pingfen1" :style="{color:fullColor,fontSize:size+'px'}"
                   v-if="starIndex>item"></i>
                <i class="iconfont icon-pingfen1" v-else-if="starIndex == item"
                   :style="{color:fullColor,fontSize:size+'px',width:starWidth}"></i>
            </span>
        </div>
        <div :style="txtStyle"><span>{{txt}}</span></div>
    </div>
</template>

<script>
    export default {
        name: "rate",
        data() {
            return {};
        },
        props: {
            value: [String,Number] ,
            txt: String,
            size: [Number,String],
            color: String,
            borderColor: String,
            fullColor: String,
            margin: String,
            txtStyle: Object
        },
        computed: {
            starIndex: function () {
                if(this.value == 0) return 0
                return parseInt(this.value) + 1
            },
            starWidth: function () {
                if (/\d*\.[\d]{0,2}$/.test(this.value)) {
                    let float = this.value.toString().split('.')[1]
                    return float.length == 1 ? float + '0%' : float + '%'
                }
            },
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @font-face {
        font-family: "iconfont";
        src: url('//at.alicdn.com/t/font_1257943_gt74tjj7co9.eot?t=1561364188621'); /* IE9 */
        src: url('//at.alicdn.com/t/font_1257943_gt74tjj7co9.eot?t=1561364188621#iefix') format('embedded-opentype'), /* IE6-IE8 */ url('data:application/x-font-woff2;charset=utf-8;base64,d09GMgABAAAAAAL8AAsAAAAABtAAAAKvAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHEIGVgCCfgqBPIErATYCJAMMCwgABCAFhG0HPBvvBRHVk3lkXxXYjeV3sOI1fO9tK4KDL7/aGEPcVNHh1AnyPAief9c+70sys8CoUCGARSiiY/crJOo91SwBXW1HT2a7jU0qSrQJRYwyuYpdAHjASfPKyRNZXGyTpCV9XEJ023XoE03IP+LPz+IS5lTagGvyF9BslAc0lwyLaEtqGuDApgOMbLINZOgbxi54gZshgCexZCOVSWMnisHuJYAsNjNjaMGPwbCUO4LdMNGEyTUs3NWZOrgafV9+5Yg7KCyNPbB1umqS+DpfV7fTg4GRveWsAJsGGsgGDEh3Y7wVIIyl8YwzyXCsVgJfLzrP1wuBETkqW4H8dW66NwDpUKOeSOZpeTQZnIICQANgJ43pQP0CDwKFBHt6btzvp2SnWxH3y7Pk0/Nh6KV4HvW8jU71Toz1z4x3HDI22Tc+OjA9kaDkbfV6RYzf7UuShP+nvsGiyJP09+fVgyr+O+OPW5fyaRWvp65qVxHr1nKIhKTdRwU9tIvW4HY1ruJFt5dClEKAs2OS9e6v/A1Rb3P9Cv+5mwHgfUGfkHyYE9xP5hD4cQUmCRzHJHOFHdMG6JB4UujUxE7MU4AnnggDtjuQL9P1IYOjILgXZAwKN2JCGne2SxrcyYaw8CIPNu6UwJMsaqZ7EcQ6QIwHkMkRgODPCyh8eQmNP+eEYT7DIpQ/sPEXDU+6JWhBL1JFa8xkzARLyH/QFNNIrknMOPOA1avPOK+IOBfktQmBaznlVIoj8hJD1nfliRAQTwMkYDvs+wlmnlosxKpF5r1tU9ObrGIaFJNkzARLyH/QFNNIQX0xK58/YPXqM+4oqwtfkNemeXAtZwCRasdBZY9yzfquPBEC4mmABFixd+ITzM3tWizEqidE572NatFQrbW9fviBElaFPV2LEi0GWW3GinDUI5urKAA=') format('woff2'),
        url('//at.alicdn.com/t/font_1257943_gt74tjj7co9.woff?t=1561364188621') format('woff'),
        url('//at.alicdn.com/t/font_1257943_gt74tjj7co9.ttf?t=1561364188621') format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+ */ url('//at.alicdn.com/t/font_1257943_gt74tjj7co9.svg?t=1561364188621#iconfont') format('svg'); /* iOS 4.1- */
    }

    .iconfont {
        font-family: "iconfont" !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .icon-pingfen:before {
        content: "\e68a";
    }

    .icon-pingfen1:before {
        content: "\e68b";
    }


    div.rate {
        display: flex;
        align-items: center;
    }

    div.star {
        position: relative;
    }

    div.star i.icon-pingfen {
        position: relative;
        font-weight: bolder;
        display: block;
    }

    div.star i.icon-pingfen1 {
        position: absolute;
        left: 0;
        top: 0;
        overflow: hidden;
        display: block;
    }

    i.rate-star {
        position: relative;
    }

    i.change-star {
        overflow: hidden;
        position: absolute;
        left: 0;
        font-weight: bolder;
    }
</style>
